import { createI18nConfig } from '@/vue/i18n'
import {
  helpers,
  required as vuelidateRequired,
  numeric as vuelidateNumeric,
  email as vuelidateEmail,
  maxLength as vuelidateMaxLength,
  requiredIf as vuelidateRequiredIf,
} from '@vuelidate/validators'

// TODO: add i18n, for now for demo we hardcode the string
// https://vuelidate-next.netlify.app/advanced_usage.html#i18n-support

const getI18nMessage = (message: string) => {
  // Warning: "Type instantiation is excessively deep and possibly infinite.ts(2589)"
  const { t } = createI18nConfig().global
  return t(message)
}

// wrap each validator.
/** required */
export const required = helpers.withMessage(
  () => getI18nMessage('Field cannot be blank'),
  vuelidateRequired,
)

/** numeric */
export const numeric = helpers.withMessage(
  () => getI18nMessage('Please enter a valid number'),
  vuelidateNumeric,
)

/** email */
export const email = helpers.withMessage(
  () => getI18nMessage('Please enter a valid email address'),
  vuelidateEmail,
)

/** requiredIf */
export const requiredIf = (val: boolean) =>
  helpers.withMessage(() => getI18nMessage('Field cannot be blank'), vuelidateRequiredIf(val))

/** maxLength */
export const maxLength = (val: number) =>
  helpers.withMessage(
    ({ $params }) => `${getI18nMessage('The maximum length allowed is')} ${$params.max}`,
    vuelidateMaxLength(val),
  )

/**
 * Required validator would not fail if the value is `false`
 * To be able to handle some checkbox that are true/false
 * we have added this custom helper
 */
export const validCheckbox = helpers.withMessage(
  () => getI18nMessage('Field is required'),
  (value: boolean) => value === true,
)
